import React from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ArrowRight } from "lucide-react";

// Desktop mega-nav with hover dropdowns. Markup/behavior preserved from Nav.jsx.
export function DesktopNav({ nav, textColor, slug }) {
  return (
    <nav className="hidden xl:flex items-center gap-7">
      {nav.map((item) => (
        <div key={item.label} className="relative group" data-testid={`nav-top-${slug(item.label)}`}>
          <button
            className={`flex items-center gap-1.5 text-[0.78rem] uppercase tracking-[0.14em] ${textColor} opacity-80 group-hover:opacity-100 transition-opacity py-2`}
          >
            {item.label}
            <ChevronDown size={13} className="opacity-60 group-hover:rotate-180 transition-transform duration-300" />
          </button>
          {/* Dropdown */}
          <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 translate-y-2 pointer-events-none group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto transition-all duration-300">
            <div className="min-w-[240px] bg-ivory rounded-md shadow-[0_24px_60px_-20px_rgba(43,35,32,0.35)] border border-espresso/10 p-3">
              {(item.children || []).map((c, j) => (
                <Link
                  key={`${c.to}-${c.label}`}
                  to={c.to}
                  data-testid={`nav-sub-${slug(item.label)}-${j}`}
                  className="block px-4 py-2.5 rounded text-sm text-espressosoft/80 hover:bg-linen hover:text-espresso transition-colors whitespace-nowrap"
                >
                  {c.label}
                </Link>
              ))}
              {item.viewAll && (
                <Link
                  to={item.viewAll.to}
                  data-testid={`nav-viewall-${slug(item.label)}`}
                  className="mt-1 flex items-center gap-2 px-4 py-2.5 rounded text-xs uppercase tracking-[0.14em] text-brass hover:bg-linen transition-colors border-t border-espresso/5"
                >
                  {item.viewAll.label} <ArrowRight size={13} />
                </Link>
              )}
            </div>
          </div>
        </div>
      ))}
    </nav>
  );
}
